<template>
	<div grey-back class="pb-4">
		<v-list subheader v-for="(category, index) in listCategories" :key="index" nopadding :class="{'margin-top-ten': index!=0}">
          	<v-subheader light subheader-semi-dense>{{category.name}}</v-subheader>
          	<v-divider></v-divider>
          	<v-list-tile v-for="(item, itemIndex) in category.items" :key="itemIndex" :disabled="!item.uri">
            	<v-list-tile-content @click="fn_openList(item)">
              		<v-list-tile-title v-html="item.title"></v-list-tile-title>
            	</v-list-tile-content>	

	            <v-list-tile-action v-if="item.showNew">
	              	<v-btn flat icon light color="primary" @click="fn_openForm(item)">
	              		<v-icon>add</v-icon>
	              	</v-btn>
	            </v-list-tile-action>
         	</v-list-tile>
        </v-list>	
	</div>
</template>

<script>
	export default{
		name: "masters",
		data(){
			return{
				"listCategories":[
									{
										"name":"Accounts",
										"key":"accounts",
										"items":[
											{
												"id":1,
												"key":"ledgers",
												"title":"Ledgers",
												"uri":"/masters/accounts/ledgers/items",
												"routeName":"ledgerItems",
												"showNew":true
											},
											{
												"id":2,
												"key":"groups",
												"title":"Groups",
												"uri":"/Masters/Accounts/Groups",
												"routeName":"accountsGroupItems",
												"showNew":true
											}
										]
									},
									{
										"name":"Inventory",
										"key":"inventory",
										"items":[
											{
												"id":1,
												"key":"items",
												"title":"Items",
												"uri":"/masters/inventory/productandservices/items",
												"routeName":"productAndServiceItems",
												"showNew":true
											},
											{
												"id":2,
												"key":"categories",
												"title":"Categories",
												"uri":"/masters/inventory/product/categories",
												"routeName":"productCategoriesItems",
												"showNew":true
											},
											{
												"id":3,
												"key":"units",
												"title":"Units",
												"uri":"/inventory/units",
												"routeName":"unitItems",
												"showNew":true
											},
											{
												"id":4,
												"key":"godowns",
												"title":"Godowns",
												"uri":"/masters/inventory/godown/items",
												"routeName":"godownItems",
												"showNew":true
											}
										]
									},
									{
										"name":"Opening",
										"key":"opening",
										"items":[
											{
												"id":1,
												"key":"ledgerOpeningBalance",
												"title":"Ledger Opening Balance",
												"uri":"/transactions/inventory/openingledger/items",
												"routeName":"openingLedgerItems",
												"showNew":true
											},
											{
												"id":2,
												"key":"openingStock",
												"title":"Opening Stock",
												"uri":"/transactions/inventory/openingstock/items",
												"routeName":"stockItems",
												"showNew":true
											}
										]
									},
									{
										"name":"Others",
										"key":"others",
										"items":[
											{
												"id":1,
												"key":"lists",
												"title":"Lists",
												"uri":"/masters/lists",
												"routeName":"listsItems",
												"showNew":false
											},
											{
												"id":3,
												"key":"expenseCategories",
												"title":"Expense Categories",
												"uri":"/masters/expensecategory/items",
												"routeName":"expenseCategoryItems",
												"showNew":true
											},
											{
												"id":3,
												"key":"expenseItems",
												"title":"Expense Items",
												"uri":"/masters/inventory/productandservices/items",
												"routeName":"productAndServiceItems",
												"showNew":true
											},
											{
												"id":4,
												"key":"serviceAccountItem",
												"title":"Service Account Item",
												"uri":"/masters/inventory/productandservices/items",
												"routeName":"productAndServiceItems",
												"showNew":true
											},
											{
												"id":5,
												"key":"taxCategory",
												"title":"Tax Category",
												"uri":"/tax/category/items",
												"routeName":"taxCategoryItems",
												"showNew":true
											},
											{
												"id":6,
												"key":"taxes",
												"title":"Taxes",
												"uri":"/addons/taxes",
												"routeName":"taxesItems",
												"showNew":true
											},
											{
												"id":7,
												"key":"discountsAndOffers",
												"title":"Discounts and Offers",
												"uri":"/addons/discounts",
												"routeName":"discountItems",
												"showNew":true
											},
											{
												"id":8,
												"key":"otherCharges",
												"title":"Other Charges",
												"uri":"/addons/othercharges",
												"routeName":"otherChargesItems",
												"showNew":true
											}
								]}]
			}
		},
		methods:{
			fn_openList: function(item){
				if(item.key === "expenseItems"){
					this.$router.push({name:item.routeName, query:{tagId:this.guidWeb(), inventory:0}, params: { 'isNew': 1 }});
				}
				else if(item.key === "serviceAccountItem"){
					this.$router.push({name:item.routeName, query:{tagId:this.guidWeb(), service_account_item:1}, params: { 'isNew': 1 }});
				}
				else{
					this.$router.push({name:item.routeName, query:{tagId:this.guidWeb()}, params: { 'isNew': 1 }});
				}
			},
			fn_openForm: function(item){
				if(item.key === "expenseItems"){
					this.$router.push({path:item.uri+'/new', query:{tagId:this.guidWeb(), inventory:0}});
				}
				else if(item.key === "serviceAccountItem"){
					this.$router.push({path:item.uri+'/new', query:{tagId:this.guidWeb(), service_account_item:1}});
				}
				else{
					this.$router.push({path:item.uri+'/new', query:{tagId:this.guidWeb()}});
				}
			},
			fn_checkHideStatus: function(){
				if(this.$root.CurrentBusiness && this.$root.CurrentBusiness.GSTRegistrationStatus && this.$root.CurrentBusiness.GSTRegistrationStatus == 1){
					return true;
				}
				else{
					return false;
				}
			}
		}
	}
</script>


// WEBPACK FOOTER //
// src/components/actions/contents/masters.vue